/* Drukke Mama's lightbox-gallery voor de PDP.
   Vervangt Dawn's product-modal (schermvullende scroll-lijst): één afbeelding
   gecentreerd, pijlen, teller, thumbnails, toetsenbord (←/→/Esc) en swipe.
   Het element draagt het id ProductModal-<section> zodat Dawn's modal-opener
   (global.js) `show(opener)` blijft aanroepen.
   Slides met de klasse dm-media-hidden (variantfilter, dm-variant-media.js)
   worden overgeslagen. */
(function () {
  if (customElements.get('dm-lightbox')) return;

  class DmLightbox extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('.dm-lightbox__stage');
      this.counter = this.querySelector('.dm-lightbox__counter');
      this.thumbs = Array.from(this.querySelectorAll('.dm-lightbox__thumb'));
      this.index = 0;

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-lightbox-close]')) this.hide();
        if (event.target.closest('[data-lightbox-prev]')) this.step(-1);
        if (event.target.closest('[data-lightbox-next]')) this.step(1);
        const thumb = event.target.closest('.dm-lightbox__thumb');
        if (thumb) this.showMedia(thumb.dataset.mediaId);
      });

      this.onKeydown = (event) => {
        if (event.key === 'Escape') this.hide();
        if (event.key === 'ArrowLeft') this.step(-1);
        if (event.key === 'ArrowRight') this.step(1);
      };

      /* Swipe op de stage */
      let startX = null;
      this.stage.addEventListener('pointerdown', (event) => (startX = event.clientX));
      this.stage.addEventListener('pointerup', (event) => {
        if (startX === null) return;
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 40) this.step(delta > 0 ? -1 : 1);
        startX = null;
      });
    }

    visibleSlides() {
      return Array.from(this.stage.querySelectorAll('.dm-lightbox__slide:not(.dm-media-hidden)'));
    }

    /* Dawn's modal-opener API */
    show(opener) {
      this.openedBy = opener;
      const li = opener?.closest('[data-media-id]');
      const mediaId = li?.dataset.mediaId?.split('-').pop();
      this.removeAttribute('hidden');
      document.body.classList.add('dm-lightbox-open');
      this.showMedia(mediaId);
      document.addEventListener('keydown', this.onKeydown);
      this.querySelector('.dm-lightbox__dialog')?.focus({ preventScroll: true });
    }

    hide() {
      this.setAttribute('hidden', '');
      document.body.classList.remove('dm-lightbox-open');
      document.removeEventListener('keydown', this.onKeydown);
      this.openedBy?.focus({ preventScroll: true });
    }

    showMedia(mediaId) {
      const slides = this.visibleSlides();
      if (!slides.length) return;
      let index = slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
      if (index === -1) index = 0;
      this.goTo(index);
    }

    step(direction) {
      this.goTo(this.index + direction);
    }

    goTo(index) {
      const slides = this.visibleSlides();
      if (!slides.length) return;
      this.index = Math.max(0, Math.min(index, slides.length - 1));
      const active = slides[this.index];

      this.stage.querySelectorAll('.dm-lightbox__slide').forEach((slide) => slide.setAttribute('hidden', ''));
      active.removeAttribute('hidden');

      if (this.counter) this.counter.textContent = `${this.index + 1} / ${slides.length}`;

      this.querySelector('[data-lightbox-prev]')?.toggleAttribute('disabled', this.index === 0);
      this.querySelector('[data-lightbox-next]')?.toggleAttribute('disabled', this.index === slides.length - 1);

      this.thumbs.forEach((thumb) => {
        const isActive = thumb.dataset.mediaId === active.dataset.mediaId;
        thumb.classList.toggle('dm-lightbox__thumb--active', isActive);
        if (isActive) thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
    }
  }

  customElements.define('dm-lightbox', DmLightbox);
})();
